import { render, staticRenderFns } from "./IconPoint.vue?vue&type=template&id=08f40ff4"
import script from "./IconPoint.vue?vue&type=script&lang=ts"
export * from "./IconPoint.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports